import { MISSION_ZONE_TYPES } from 'utils/constants'
import { IZone } from 'utils/interfaces'

export interface ZoneFormCache {
  // Zone editing / Route editing fields
  name?: string
  description?: string
  selectedZoneType?: MISSION_ZONE_TYPES
  cleaningSpeed?: number
  transportSpeed?: number
  isBorderCleaning?: boolean
  tempRouteName?: string
  // Settings fields
  turbineSpeed?: number
  frontDustSuppression?: boolean
  scrubberBrushSpeed?: number
}

export type ZoneFormCacheKey = keyof ZoneFormCache

export type GetCacheValue = <K extends ZoneFormCacheKey>(key: K) => ZoneFormCache[K]
export type SetCacheValue = <K extends ZoneFormCacheKey>(key: K, value: ZoneFormCache[K]) => void
export type GetAllCacheValues = () => ZoneFormCache

export interface ZoneFormCacheProps {
  getCacheValue?: GetCacheValue
  setCacheValue?: SetCacheValue
  getAllCacheValues?: GetAllCacheValues
}

export interface OnSaveClickedParams {
  zoneName: string
  zoneDescription: string
  zoneType: MISSION_ZONE_TYPES
  cleaningSpeed?: number
  transportSpeed?: number
  isBorderCleaning?: boolean
  equipment_setup?: { turbine_speed?: number; front_dust_suppression?: boolean; scrubber_brush_speed?: number }
}

export type OnSaveClicked = (params: OnSaveClickedParams) => void | Promise<void>

export interface ZoneFormComponentProps extends ZoneFormCacheProps {
  onSaveClicked: OnSaveClicked
  zone?: IZone
}

export const getLatestZone = (cleaningZones: any[], zoneId?: number): any | null => {
  if (!zoneId) return null
  return cleaningZones.find((z: any) => z.properties?.zone_id === zoneId) || null
}
